import type { ChannelParams } from "../..";
import { useEffect, useState } from "react";

type ContractFormMode = "new" | "edit";

/**
 * Freezes which channels/groups appear in the top vs collapsed sections during edit,
 * so toggling activation does not jump rows between sections mid-session.
 */
export function useFrozenChannelDisplayPartition(
    mode: ContractFormMode,
    isEditChannelsReady: boolean,
    chosenChannels: ChannelParams[],
    activeGroups: number[],
) {
    const [displayPartitionChannelIds, setDisplayPartitionChannelIds] = useState<number[] | null>(null);
    const [displayPartitionGroupIds, setDisplayPartitionGroupIds] = useState<number[] | null>(null);

    useEffect(() => {
        if (mode !== "edit") {
            setDisplayPartitionChannelIds(null);
            setDisplayPartitionGroupIds(null);
            return;
        }
        if (!isEditChannelsReady) {
            setDisplayPartitionChannelIds(null);
            setDisplayPartitionGroupIds(null);
        }
    }, [mode, isEditChannelsReady]);

    useEffect(() => {
        if (mode !== "edit" || !isEditChannelsReady || displayPartitionChannelIds !== null) {
            return;
        }
        setDisplayPartitionChannelIds((chosenChannels ?? []).map((item) => item.channelId));
        setDisplayPartitionGroupIds([...activeGroups]);
    }, [mode, isEditChannelsReady, chosenChannels, activeGroups, displayPartitionChannelIds]);

    const resetDisplayPartition = () => {
        setDisplayPartitionChannelIds(null);
        setDisplayPartitionGroupIds(null);
    };

    return {
        displayPartitionChannelIds,
        displayPartitionGroupIds,
        resetDisplayPartition,
    };
}
